import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import {
  IsoDateSelectorComponent,
  NgCommonModule,
} from '@principle-theorem/ng-shared';
import { AccExistingClaimFormGroup } from './acc-existing-claim.formgroup';

@Component({
  selector: 'pr-acc-existing-claim-form',
  imports: [
    NgCommonModule,
    MatFormFieldModule,
    MatInput,
    IsoDateSelectorComponent,
  ],
  templateUrl: './acc-existing-claim-form.component.html',
  styleUrl: './acc-existing-claim-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccExistingClaimFormComponent {
  form = input.required<AccExistingClaimFormGroup>();
}
